const content = [
  'роль наставника;',
  'цели наставничества;',
  'алгоритм передачи опыта;',
  'обучение на рабочем месте;',
  'постановка развивающих задач;',
  'наблюдение;',
  'обратная связь;',
  'вопросы вместо готовых ответов;',
  'работа с ошибками;',
  'развитие самостоятельности;',
  'контроль прогресса;',
  'сложные ситуации наставничества;',
  'взаимодействие с руководителем;',
  'подготовка преемников.',
];

export default function TrainMentors() {
  return (
    <section className="py-16 md:py-24 bg-gray-50">
      <div className="max-w-5xl mx-auto px-6">
        <h2 className="text-2xl md:text-4xl font-bold text-gray-900 text-center mb-4">
          Как обучать наставников
        </h2>
        <p className="text-base md:text-lg text-gray-600 text-center max-w-3xl mx-auto mb-12 leading-relaxed">
          Программа развития навыков наставника может включать следующие темы — этот набор адаптируется под компанию и задачи, а не является единственно обязательным:
        </p>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-3 max-w-4xl mx-auto">
          {content.map((c, i) => (
            <div key={i} className="flex items-start gap-2.5 bg-white rounded-lg border border-gray-200 p-4 hover:border-teal-300 transition-colors">
              <i className="ri-checkbox-circle-line text-teal-600 mt-0.5 flex-shrink-0"></i>
              <span className="text-sm text-gray-700 leading-relaxed">{c}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}